import React, { useState } from "react";
import FileUploader from "../FileUploader/FileUploader";
import UploadHelper from "../../helpers/upload";
import styles from "./VideoUploadForm.module.scss";

function VideoUploadForm({ uploading, progress, onFileChange }) {
  return (
    <div>
      <FileUploader
        title="Upload a Video"
        uploading={uploading}
        progress={progress}
        onFileChange={onFileChange}
        accept="video/mp4,video/x-m4v,video/*"
      />
    </div>
  );
}

export default VideoUploadForm;
